import { getCustPayTypes } from '@/api/user.js';
import { initCustPayTypes, clearCustPayTypesCache, updateCustPayTypesCache } from '@/utils/cacheService';

let defaultInfo = {
  auditStatus:'',
  authorities:'',
  createTime:'',
  custLvl:'',
  custSource:'',
  custStatus:'',
  custType:'',
  email:"",
  enabled:'',
  hierarchy:'',
  id:'',
  phone:"",
  savedate:'',
  timeout:'',
  username:"",
  firstName: '',
  portraitImg: ''
};
const user = {
  state: {
    userInfo: defaultInfo,
    custPayTypes: null,
    custPayTypesPromise: null,
    hideBackToTop: false,
    // 出金时的信息
    payUserInfo: null,
    subIbJumpToAccountListOfId: 0,
    withdrawAccount: '',
    depositAccount: '',
    noticeDialogShow: false,
    noticeDialogInfo:{
      id: '',
      title: '',
      updateTime: '',
      content: ''
    },

    withdrawDefaultPageTitle: '',
    withdrawDefaultType: 1,
    agentRole: localStorage.getItem('agentRole') || 'CUSTOMER',// IB或者CUSTOMER
  },

  mutations: {
    setUserInfo(state,userInfo){
        state.userInfo = userInfo;
        if (userInfo && userInfo.id) {
          state.custPayTypesPromise = initCustPayTypes(getCustPayTypes, userInfo.id).then((data) => {
            state.custPayTypes = data;
            return data;
          }).catch((err) => {
            throw err;
          });
        }
    },
    setLocalUserInfo(state,userInfo){
        state.userInfo = userInfo;
        if (userInfo && userInfo.id) {
          state.custPayTypesPromise = initCustPayTypes(getCustPayTypes, userInfo.id).then((data) => {
            state.custPayTypes = data;
            return data;
          }).catch((err) => {
            throw err;
          });
        }
    },
    setCustPayTypes(state, data) {
      state.custPayTypes = data;
      updateCustPayTypesCache(data, state.userInfo && state.userInfo.id);
    },
    clearUserInfo(state){
      state.userInfo = null;
      state.custPayTypes = null;
      state.custPayTypesPromise = null;
      clearCustPayTypesCache();
    },
    // 出金时的信息
    setPayUserInfo(state,payUserInfo){
      state.payUserInfo = payUserInfo;
    },
    setSubIbJumpToAccountListOfId(state,subIbJumpToAccountListOfId){
      state.subIbJumpToAccountListOfId = subIbJumpToAccountListOfId;
    },
    setWithdrawAccount(state,withdrawAccount){
      state.withdrawAccount = withdrawAccount;
    },
    setDepositAccount(state,depositAccount){
      state.depositAccount = depositAccount;
    },
    setNoticeDialogShow(state,falg){
      state.noticeDialogShow = falg;
    },
    setNoticeDialogInfo(state,info){
      state.noticeDialogInfo = info;
    },
    setWithdrawDefaultPageTitle(state,withdrawDefaultPageTitle){
      state.withdrawDefaultPageTitle = withdrawDefaultPageTitle;
    },
    setWithdrawDefaultType(state,withdrawDefaultType){
      state.withdrawDefaultType = withdrawDefaultType;
    },
    setAgentRole(state,agentRole){
      state.agentRole = agentRole;
    },
    setHideBackToTop(state, hide) {
      state.hideBackToTop = hide;
    },
  },

  actions: {
    ensureCustPayTypes({ state }) {
      if (state.custPayTypes) {
        return Promise.resolve(state.custPayTypes);
      }
      if (state.custPayTypesPromise) {
        return state.custPayTypesPromise;
      }
      return Promise.reject(new Error('User not initialized'));
    },
    // Binding edits must bypass the login-time cache so pages do not read stale payee info.
    refreshCustPayTypes({ state, commit }) {
      if (!state.userInfo || !state.userInfo.id) {
        return Promise.reject(new Error('User not initialized'));
      }
      state.custPayTypesPromise = getCustPayTypes({ custId: state.userInfo.id }).then((res) => {
        commit('setCustPayTypes', res.data);
        return res.data;
      }).catch((err) => {
        state.custPayTypesPromise = null;
        throw err;
      });
      return state.custPayTypesPromise;
    }
  },
  getters:{
    userInfo: state => state.userInfo,
    custPayTypes: state => state.custPayTypes,
    // 出金时的信息
    payUserInfo: state => state.payUserInfo,
    subIbJumpToAccountListOfId: state => state.subIbJumpToAccountListOfId,
    withdrawAccount: state => state.withdrawAccount,
    depositAccount: state => state.depositAccount,
    localUserInfo: state => state.localUserInfo,
    noticeDialogShow: state => state.noticeDialogShow,
    noticeDialogInfo: state => state.noticeDialogInfo,
    withdrawDefaultPageTitle: state => state.withdrawDefaultPageTitle,
    withdrawDefaultType: state => state.withdrawDefaultType,

    agentRole: state => state.agentRole,// 代理用户当前的角色
    hideBackToTop: state => state.hideBackToTop,
  }
};

export default user;
